import { render, staticRenderFns } from "./HomonymyItem.vue?vue&type=template&id=44a3c879&scoped=true&"
import script from "./HomonymyItem.vue?vue&type=script&lang=ts&"
export * from "./HomonymyItem.vue?vue&type=script&lang=ts&"
import style0 from "./HomonymyItem.vue?vue&type=style&index=0&id=44a3c879&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a3c879",
  null
  
)

export default component.exports